<template>
    <div>
        <div class="ecitem-tile">
            <router-link :to="{ name: 'ecItemContent', query: { ecitem_id: ecItemId, title: ecItemName } }"
                class="text-decoration-none">
                <div class="ecitem-tile__thumbnail ecitem-tile__thumbnail--default rounded-lg">
                    <div class="ecitem-tile-thumbnail__cover rounded-lg"
                        :style="{ backgroundImage: `url(${thumbnailUri})` }"></div>
                </div>
            </router-link>
            <div class="ecitem-tile__body ecitem-tile-body">
                <div class="mb-auto">
                    <router-link :to="{ name: 'ecItemContent', query: { ecitem_id: ecItemId, title: ecItemName } }"
                        class="text-decoration-none">
                        <div>
                            <v-chip v-if="chip" variant="outlined" color="primary" :input-value="true" size="x-small"
                                class="ecitem-tile-body__chip mb-2" label>{{ chip }}</v-chip>
                        </div>
                        <div class="ecitem-tile-body__title ellipsis1">{{ ecItemName }}</div>
                        <div class="ecitem-tile-body__lead ellipsis1 mb-1">{{ partnerName }}</div>
                        <div class="ecitem-tile-body__lead ellipsis2">{{ decodeHtmlEscape(explanation) }}</div>
                    </router-link>
                </div>
                <div class="d-flex justify-end">
                    <div class="ecitem-tile-body__price mr-3">
                        <span v-if="ecItemPrice">{{ price }} 円</span>
                    </div>
                    <div>
                        <v-btn :loading="isLoading" id="id-watch-icon" :class="{ 'checked': isWatched }" size="small"
                            background-color="white" :ripple="false" variant="text" icon="mdi-heart" density="compact"
                            @click="onClickedWatch">
                        </v-btn>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '../assets/js/helper'
import axios from 'axios'
const watchListApi = '/api/watch/item/save'

export default {
    name: 'EcTile',
    props: {
        'ecItemId': {
            type: String,
            default: ''
        },
        'ecItemName': {
            type: String,
            default: ''
        },
        'ecItemPrice': {
            type: String,
            default: ''
        },
        'explanation': {
            type: String,
            default: ''
        },
        'thumbnailUri': {
            type: String,
            default: ''
        },
        chip: {
            type: String,
            default: ''
        },
        'isWatch': {
            type: Boolean
        },
        'supporter': {
            type: Number
        },
        'partnerName': {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isWatched: false,
            isLoading: false,
        }
    },
    computed: {
        price: function () {
            return Helper.addComma(this.ecItemPrice)
        },
    },
    mounted() {
        this.isWatched = this.isWatch
     },
    watch: {
        isWatch(value) {
            this.isWatched = value;
        }
    },
    methods: {
        decodeHtmlEscape(string) {
            return Helper.decodeHtmlEscape(string)
        },
        onClickedWatch() {
            (async () => {
                try {
                    this.isLoading = true
                    var params = new URLSearchParams();
                    params.append('ec_item_id', this.ecItemId);
                    params.append('mode', this.isWatched ? 'del' : 'add');
                    const response = await axios.post(watchListApi, params)
                    console.log(response)
                    this.isWatched = !this.isWatched

                } catch (error) {
                    console.log(error)
                    alert('ウォッチリストの登録に失敗しました。画面右上のリロードボタンからページを更新後、再度お試しください。')
                } finally {
                    setTimeout(() => {
                        this.isLoading = false                        
                    }, 500);
                }
            })()
        }
    }
}
</script>

<style scoped>
.ecitem-tile {
    display: flex;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
}

.ecitem-tile__thumbnail {
    width: 112px;
    aspect-ratio: 1;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.ecitem-tile__thumbnail--default {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-color: #aaa;
    background-image: url('../assets/images/empty.gif');
}

.ecitem-tile-thumbnail__cover {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.ecitem-tile__body {
    width: calc(100% - 120px);
}

.ecitem-tile-body {
    display: flex;
    flex-flow: column;
    text-align: left;
    justify-content: space-between;
}

.ecitem-tile-body__chip {
    font-weight: 600;
}

.ecitem-tile-body__title {
    font-size: 0.9em;
    font-weight: bold;
}

.ecitem-tile-body__lead {
    color: #666;
    font-size: 0.75em;
}

.ecitem-tile-body__price {
    text-align: right;
    font-size: 1.0em;
    font-weight: 600;
}

#id-watch-icon {
    color: #cccccc;
}

#id-watch-icon.checked {
    color: #ff0000;
}
</style>
